module.exports = __webpack_public_path__ + "img/airplane-3.a0a50a0b.jpg";